<template>
  <div class="shop-info-tab">
    <div
      ref="scrollable"
      class="info-tab no-scrollbar"
      v-on:scroll.passive="onScroll"
    >
      <ShopProfileMap
        v-if="showBigMap && business"
        :key="business.id + 2"
        :big="true"
        :locations="locations"
        :business="business"
        :commerce="commerce"
        @closeBig="closeBigMap"
      />

      <ShopOrderNow v-if="commerce" style="margin-bottom: 4px" />

      <div v-if="!commerce" style="height: 56px" />

      <div class="divider" />

      <div class="new-card">
        <!-- <div class="card-content"> -->
        <!-- <div class="content has-text-left"> -->
        <p class="field-name">
          {{ $t("shop.hours") }}
          <fade-transition>
            <i v-show="showCOVID" class="covid has-text-grey">
              {{ $t("shop.hours-vary-covid") }}
            </i>
          </fade-transition>
        </p>
        <p style="margin-bottom: 0" @click="openHours">
          <i class="far fa-clock" />&nbsp;
          <span class="has-text-weight-medium" :class="openClosed.class">{{
            openClosed.text
          }}</span>
          <span class="icon" style="margin-left: 10px" @click="openHours">
            <i class="far fa-calendar-alt" style="margin-right: 5px" />
            <!-- <i class="fa fa-ellipsis-v" /> -->
          </span>
          <span class="link" style="margin-left: 0px">
            <span v-if="hoursAlwaysOpen">{{ $t("always-open") }}</span>
            <span v-else @click="openHours"
              >{{ $t("today") }} {{ todaysHours }}</span
            >
          </span>
        </p>
        <!-- </div> -->
        <!-- </div> -->
      </div>

      <div class="divider" />
      <div class="new-card" style="padding-bottom: 6px">
        <p class="field-name">{{ $t("shop.contact") }}</p>
        <div class="contact-grid">
          <div>
            <p class="single-line" style="margin-bottom: 0">
              <i class="fa fa-phone" />&nbsp;
              <span class="link" @click="callPhoneNumber(data.phone_number)">{{
                data.phone_number
              }}</span>
            </p>
          </div>
          <div>
            <p
              v-if="data.email"
              class="single-line no-scrollbar email"
              style="margin-bottom: 0"
            >
              <i class="far fa-envelope" />&nbsp;
              <span @click="emailTo(data.email)">
                {{ $t("shop.email-the-shop") }}
                <i class="fa fa-external-link-alt fa-sm" />
              </span>
            </p>
          </div>
          <div>
            <p v-if="data.website" class="single-line" style="margin-bottom: 0">
              <i class="fa fa-globe" />&nbsp;
              <span @click="openWebsite(data.website)">
                <!-- {{ shortenURL(data.website) }} -->
                {{ $t("shop.visit-shop-website") }}
                <i class="fa fa-external-link-alt fa-sm" />
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="divider" />
      <div class="new-card">
        <!-- <div class="v-spacer" /> -->
        <p class="field-name">{{ $t("shop.categories") }}</p>

        <p class="clamp">
          <i class="fa fa-shopping-basket" />&nbsp;
          <span>{{ parseCategories(data.categories) }}</span>
        </p>
      </div>
      <div class="divider" />
      <div class="new-card">
        <!-- <div class="v-spacer" /> -->

        <p class="field-name">
          {{ $t("shop.address") }}
        </p>
        <p class="clamp" style="margin-bottom: 6px">
          <i class="fa fa-map-marker-alt" />&nbsp;
          <span class="link" @click="openGoogleMaps">{{ address }}</span>
        </p>
        <p style="margin-bottom: 2px; text-align: left">
          <span class="tag" @click="triggerBigMap">
            {{ $t("shop.view-on-map") }}
            <i class="fa fa-globe-asia" style="margin-left: 5px" /> </span
          >&nbsp;
          <span
            v-if="business.country === 'th'"
            class="tag has-text-info has-text-weight-medium"
            @click="rideToShop"
          >
            {{ $t("shop.request-ride-to-shop") }}
            <i class="fa fa-chevron-right" style="margin-left: 5px" />
          </span>
        </p>
        <!-- </div>
        </div> -->
        <div class="small-map-wrapper" @click="triggerBigMap">
          <ShopProfileMap
            v-if="!showBigMap && business"
            :key="business.id + 1"
            :big="false"
            :locations="locations"
            :business="business"
            :commerce="commerce"
            class="small-map"
          />
        </div>
      </div>

      <div v-if="priceList">
        <div class="divider" />
        <div class="new-card">
          <p class="field-name">
            {{ $t("shop.price-list") }}
          </p>
          <div style="white-space: pre-wrap">
            <p>{{ priceList }}</p>
          </div>
        </div>
      </div>

      <div v-if="data.blurb || data.quotes">
        <div class="divider" />
        <div class="new-card">
          <!-- <div class="card-content"> -->
          <p class="field-name">
            {{ $t("shop.description") }}
          </p>
          <p class="blurb">{{ data.blurb }}</p>
          <div v-if="quotes.length > 0">
            <br />
            <p class="field-name">
              {{ $t("shop.customers-say") }}
            </p>
            <p v-for="q in quotes" :key="q" class="quotes">
              <i>{{ q }}</i>
            </p>
          </div>
          <!-- </div> -->
        </div>
      </div>

      <div v-if="data.review_sites">
        <div class="divider" />
        <ShopReviewSites />
      </div>

      <div v-if="!commerce">
        <div class="divider" />
        <div
          class="new-card has-text-centered"
          @click="contactFBMessengerSupport"
        >
          <!-- <div class="card-content" style="padding: 16px; line-height: 1.8em"> -->
          <svgicon
            icon="tuk-word"
            width="40"
            height="40"
            color="navy"
            :fill="true"
            style="margin-top: -17px"
          ></svgicon>
          <span class="tuk-shop">SHOP</span>
          <!-- <br /> -->
          <p class="has-text-grey subtitle is-6">
            {{ $t("commerce.need-commerce") }}
            <i class="fa fa-chevron-right" style="margin-left: 4px" />
            <!-- <br /> -->
            <!-- <img
              src="/img/home2/bird.svg"
              style="height: 25px; margin-bottom: -7px"
            /> -->
            <!-- {{ $t("commerce.tuk-can-do-it") }}&nbsp; -->
            <!-- <a
              class="button is-small is-rounded is-primary is-outlined pulse"
              href="https://m.me/tukapp"
              >{{ $t("click-here") }}</a
            > -->
          </p>
        </div>
      </div>

      <div v-if="$store.getters.isSuperUser">
        <div class="divider" />

        <ShopSuperuser :isWhiteLabel="isWhiteLabel" @brandStory="brandStory" />
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus";
import ShopProfileMap from "@/components/ShopProfileMap.vue";
import ShopOrderNow from "@/components/ShopOrderNow.vue";
import ShopReviewSites from "@/components/ShopReviewSites.vue";
import ShopSuperuser from "@/components/ShopSuperuser.vue";

export default {
  name: "ShopInfoTab",
  components: {
    ShopProfileMap,
    ShopOrderNow,
    ShopReviewSites,
    ShopSuperuser,
  },
  props: {
    isWhiteLabel: Boolean,
  },
  watch: {
    tab() {},
  },
  data() {
    return {
      showCOVID: false,
      showBigMap: false,
    };
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
    data() {
      return this.business.data;
    },
    address() {
      if (!this.business) return null;
      return this.business.address; //this.business.address.split(",")[0];
    },
    commerce() {
      if (!this.business.workflows) return null;
      var commerce = this.business.workflows.find((w) => w.name === "Commerce");
      return commerce;
      // if (!commerce) return null;
      // return commerce.data.channels;
    },
    locations() {
      if (!this.commerce) return null;
      return this.commerce.data.locations;
    },
    businessMap() {
      var lat = this.business.lat;
      var lon = this.business.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    quotes() {
      if (!this.data.quotes) return [];
      return this.data.quotes.split("<br>");
    },
    priceList() {
      if (!this.data.price_info) return null;
      return this.data.price_info;
    },
    closedUntil() {
      if (!this.commerce || !this.commerce.data.closed_until) return null;
      return this.isFutureTime(this.commerce.data.closed_until);
      // return this.shortDateTime(this.commerce.data.closed_until);
    },
    hoursAlwaysOpen() {
      if (!this.data.hours_type) return true;
      if (this.data.hours_type === "always-open") return true;
      if (!this.data.hours) return true; // if selected-hours are blank
      return false;
    },
    todaysHours() {
      if (this.closedUntil) return this.$t("commerce.on-holiday");
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" }); //  timeZone: "America/New_York",
      if (!this.data.hours) return this.$t("shop.closed");
      var hours = this.data.hours[today.toLowerCase()];
      return hours || this.$t("shop.closed");
    },
    openClosed() {
      var open = { text: this.$t("shop.open"), class: "has-text-success" };
      var closed = { text: this.$t("shop.closed"), class: "has-text-danger" };
      if (this.closedUntil) return closed;
      if (this.data.hours_type === "always-open") return open;
      if (!this.data.hours) return open; // unknown hours, say open
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hours = this.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) {
        // if (this.openNow(hours)) {
        return open;
      }
      return closed;
    },
  },
  mounted() {
    console.log("re-mount ShopInfo");
    this.triggerShowCOVID(); // show COVID warning timer
    // EventBus.$on("SHOP_INFO_TAB", () => {
    //   this.init();
    // });
  },
  // beforeDestroy() {
  //   EventBus.$off("SHOP_INFO_TAB");
  // },
  methods: {
    // init() {
    //   console.log("init InfoTab");
    //   this.triggerShowCOVID();
    //   this.showBigMap = false;
    // },
    brandStory() {
      this.$emit("brandStory");
    },
    triggerBigMap() {
      this.showBigMap = true;
      this.$refs.scrollable.scrollTo(0, 0);
      setTimeout(() => this.$emit("scrollTop", 1), 200);
    },
    closeBigMap() {
      this.showBigMap = false;
      this.$emit("scrollTop", 0);
    },
    onScroll() {
      if (!this.$refs.scrollable) return;
      var scrollTop = this.$refs.scrollable.scrollTop;
      this.$emit("scrollTop", scrollTop);
    },
    rideToShop() {
      // need to pass shop as dropoff detail to ride page...
      this.goToRide();
    },
    emailTo(email) {
      window.location.href = `mailto:${email}?subject=I found your shop on TUK 🦜`;
    },
    parseCategories(str) {
      if (!str) return;
      var arr = str
        .split(",")
        .map((s) => {
          s = s.trim();
          if (!s.startsWith("_")) return s.replace(/\*/g, ""); // s.replaceAll("*", "");
        })
        .filter((s) => s);
      return arr.join(", ");
    },
    triggerShowCOVID() {
      this.showCOVID = true;
      setTimeout(() => (this.showCOVID = false), 4000);
    },
    openHours() {
      var d1 = this.$t("dow.mon");
      var d2 = this.$t("dow.tue");
      var d3 = this.$t("dow.wed");
      var d4 = this.$t("dow.thu");
      var d5 = this.$t("dow.fri");
      var d6 = this.$t("dow.sat");
      var d7 = this.$t("dow.sun");
      if (this.hoursAlwaysOpen) {
        var txt = this.$t("always-open");
        this.$swal({
          showCloseButton: true,
          showConfirmButton: false,
          html: `<div class='hours-modal'><table><tbody>
<tr><td>${d1}:</td><td>${txt}</td></tr>
<tr><td>${d2}:</td><td>${txt}</td></tr>
<tr><td>${d3}:</td><td>${txt}</td></tr>
<tr><td>${d4}:</td><td>${txt}</td></tr>
<tr><td>${d5}:</td><td>${txt}</td></tr>
<tr><td>${d6}:</td><td>${txt}</td></tr>
<tr><td>${d7}:</td><td>${txt}</td></tr>
</tbody></table></div>`,
        });
        return;
      }
      var mon = this.data.hours.mon || this.$t("shop.closed");
      var tue = this.data.hours.tue || this.$t("shop.closed");
      var wed = this.data.hours.wed || this.$t("shop.closed");
      var thu = this.data.hours.thu || this.$t("shop.closed");
      var fri = this.data.hours.fri || this.$t("shop.closed");
      var sat = this.data.hours.sat || this.$t("shop.closed");
      var sun = this.data.hours.sun || this.$t("shop.closed");
      this.$swal({
        showCloseButton: true,
        showConfirmButton: false,
        html: `<div class='hours-modal'><table><tbody>
<tr><td>${d1}:</td><td>${mon}</td></tr>
<tr><td>${d2}:</td><td>${tue}</td></tr>
<tr><td>${d3}:</td><td>${wed}</td></tr>
<tr><td>${d4}:</td><td>${thu}</td></tr>
<tr><td>${d5}:</td><td>${fri}</td></tr>
<tr><td>${d6}:</td><td>${sat}</td></tr>
<tr><td>${d7}:</td><td>${sun}</td></tr>
</tbody></table></div>`,
      });
    },
    openGoogleMaps() {
      window.open(this.businessMap, "_blank");
    },
    openWebsite(url) {
      var http = url;
      if (!url.startsWith("http")) http = "https://" + url;
      window.open(http, "_blank"); // need to add https or won't know it's an external web link
    },
    shortenURL(url) {
      if (!url) return null;
      // remove https://www etc then shorten
      url = url.replace("https://www.", "");
      url = url.replace("http://www.", "");
      url = url.replace("https://", "");
      url = url.replace("http://", "");
      return url;
      // return this.shortenString(url, 20);
    },
  },
};
</script>

<style scoped>
.info-tab {
  position: relative;
  height: 100vh;
  max-height: calc(100vh - 200px);
  overflow: scroll;
  font-size: 0.9em;
  padding-bottom: 30px;
  max-width: 700px;
  margin: auto;
}
.v-spacer {
  height: 24px;
}
.field-name {
  margin-bottom: 0;
  /* line-height: 0pt; */
  font-size: 0.8em;
  opacity: 0.6;
}
.new-card {
  background-color: white;
  margin-top: 1px;
  margin-bottom: 4px;
  overflow-x: hidden;
  padding: 12px;
  text-align: left;
}
.small-map-wrapper {
  width: 100vw;
  max-width: 700px;
  height: 100px;
  margin-left: -12px;
  margin-top: 12px;
}
.pulse {
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px lightgreen;
  }
  100% {
    box-shadow: 0 0 0 3px rgba(144, 238, 144, 0.5);
  }
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  /* margin-bottom: -10px; */
  display: inline-block;
}
/* clamp ellipsis to 2 lines */
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 4px;
}
.clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  padding-right: 4px;
}
.covid {
  font-size: 1.1em;
  /* margin-bottom: 4px; */
  margin-top: -6px;
  /* margin-left: 10px; */
  /* float: right; */
  font-weight: 500;
  position: absolute;
  right: 10px;
}
.blurb {
  text-align: left;
  white-space: pre-wrap;
}
.quotes {
  text-align: left;
  padding-bottom: 5px;
}
.contact-grid {
  display: flex;
  flex-wrap: wrap;
  /* width: 100%; */
}
.contact-grid div {
  flex-basis: 50%;
  position: relative;
  /* height: 24px; */
}
.email {
  max-width: calc(50vw - 15px);
  overflow: scroll;
}
.link {
  border-bottom: 1px #ccc dotted;
}
.tuk-shop {
  font-size: 15pt;
  font-weight: 550;
  color: #fac002;
  /* margin-top: 4px; */
  margin-left: 3px;
  /* position: absolute; */
}
.divider {
  height: 2px;
}
</style>

<style>
.hours-modal td {
  padding: 5px;
}
</style>